import { createAxiosInstance } from '../utils/axiosConfig';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8083/api';

// Create axios instance with default config and interceptors
const auditAPI = createAxiosInstance({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor for error handling
auditAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred';
    console.error('API Error:', errorMessage);
    return Promise.reject(errorMessage);
  }
);

export const auditService = {
  // Get security logs with filters
  getSecurityLogs: async (params = {}) => {
    try {
      const { 
        page = 0, 
        size = 50, 
        sortBy = 'timestamp', 
        sortDir = 'desc',
        status,
        userId,
        userEmail,
        startDate,
        endDate
      } = params;
      
      const queryParams = { page, size, sortBy, sortDir };
      if (status) queryParams.status = status;
      if (userId) queryParams.userId = userId;
      if (userEmail) queryParams.userEmail = userEmail;
      if (startDate) queryParams.startDate = startDate;
      if (endDate) queryParams.endDate = endDate;
      
      const response = await auditAPI.get('/audit/security-logs', {
        params: queryParams
      });
      return response.data;
    } catch (error) {
      throw new Error(error || 'Failed to fetch security logs');
    }
  },
  
  // Log page view
  logPageView: async (pagePath, userRole = 'GUEST') => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const response = await auditAPI.post('/audit/log-page-view', {
        pagePath,
        userId: user.id || null,
        userEmail: user.email || null,
        userRole: userRole || (user.role || 'GUEST')
      });
      return response.data;
    } catch (error) {
      // Don't throw error for logging failures
      console.error('Failed to log page view:', error);
    }
  },
  
  // Log product view
  logProductView: async (productId, userRole = 'GUEST') => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const response = await auditAPI.post('/audit/log-product-view', {
        productId,
        userId: user.id || null,
        userEmail: user.email || null,
        userRole: userRole || (user.role || 'GUEST')
      });
      return response.data;
    } catch (error) {
      // Don't throw error for logging failures
      console.error('Failed to log product view:', error);
    }
  },
  
  // Log add to cart
  logAddToCart: async (productId, quantity, userRole = 'GUEST') => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const response = await auditAPI.post('/audit/log-add-to-cart', {
        productId,
        quantity,
        userId: user.id || null,
        userEmail: user.email || null,
        userRole: userRole || (user.role || 'GUEST')
      });
      return response.data;
    } catch (error) {
      // Don't throw error for logging failures
      console.error('Failed to log add to cart:', error);
    }
  },

  // Get failed login attempts
  getFailedLoginAttempts: async (params = {}) => {
    try {
      const { page = 0, size = 50 } = params;
      const response = await auditAPI.get('/audit/failed-logins', {
        params: { page, size }
      });
      return response.data;
    } catch (error) {
      throw new Error(error || 'Failed to fetch failed login attempts');
    }
  },

  // Get all audit logs
  getAllAuditLogs: async (params = {}) => {
    try {
      const { page = 0, size = 50, sortBy = 'timestamp', sortDir = 'desc' } = params;
      const response = await auditAPI.get('/audit/logs', {
        params: { page, size, sortBy, sortDir }
      });
      return response.data;
    } catch (error) {
      throw new Error(error || 'Failed to fetch audit logs');
    }
  }
};

export default auditService;

